import { graphql } from 'gatsby';
import React, { FC, ReactElement } from 'react';
import { ConfigYamlSlogans, ConfigYamlTeges, SiteSiteMetadata } from '../../gatsby-types';
import { Footer } from '../layout/Footer';
import { Nav } from '../layout/Nav';
import { TegeContainer } from '../layout/TegeContainer';

type Props = Readonly<{
  data: {
    site: {
      siteMetadata: SiteSiteMetadata;
    }
    allConfigYaml: {
      edges: [
        {
          node: {
            teges: Array<ConfigYamlTeges>;
            slogans: ConfigYamlSlogans;
          }
        }
      ]
    }
  }
}>;

const Index: FC<Props> = ({ data }): ReactElement => {
  return (
    <div>
      <Nav title={data.site.siteMetadata.title}/>
      <TegeContainer teges={data.allConfigYaml.edges[0].node.teges}/>
      <Footer slogans={data.allConfigYaml.edges[0].node.slogans}/>
    </div>
  );
};

export default Index;

export const pageQuery = graphql`
  query SuperMisc {
    site {
      siteMetadata {
        title
      }
    }
    allConfigYaml {
      edges {
        node {
          teges {
            tegename
            tegegenre
            tegeeasiness
            tegetime
            tegepersons
            tegeage
            tegedescription
            tegeimpression
            tegeimage
          }
          slogans {
            ja
            en
            fr
            es
            zh
          }
        }
      }
    }
  }
`;
